/**
 * Feature preferences API service
 */

import { api } from '@services/api';
import { API_PATHS } from '@utils/constants';
import { ConfigurableFeaturesResponseSchema } from '../schemas/feature.schemas';
import type { ConfigurableFeature } from '../schemas/feature.schemas';

export const featureApi = {
  /**
   * Get configurable feature preferences for the current user
   */
  getPreferences: async (): Promise<ConfigurableFeature[]> => {
    const response = await api.get(API_PATHS.FEATURES_PREFERENCES);
    const data: unknown = response.data;
    return ConfigurableFeaturesResponseSchema.parse(data).features;
  },

  /**
   * Update preferences for a specific feature
   */
  updatePreference: async (
    featureId: string,
    options: Record<string, unknown>,
  ): Promise<void> => {
    await api.put(`${API_PATHS.FEATURES_PREFERENCES}/${featureId}`, {
      options,
    });
  },
};
